<script>
export default {
  props: {
    customAttributeValues: Array,
  },
  methods: {
    isPresent(customAttributeValue) {
      const value = customAttributeValue.value

      if (customAttributeValue.castTo == 'integer') return value != undefined
      if (Array.isArray(value)) return value.length > 0
      return !!value
    },
    icon(customAttributeValue) {
      if (customAttributeValue.castTo == 'boolean') {
        return customAttributeValue.value ? 'bi-check-circle' : 'bi-circle'
      }
      return this.isPresent(customAttributeValue) ? 'bi-chat-square-text' : 'bi-chat-square'
    },
    // A single selection is one option, a multi selection a list of them
    labels(customAttributeValue) {
      return [customAttributeValue.value].flat().map((entry) => entry.label).join(', ')
    },
  },
};
</script>

<template>
  <div v-if="this.customAttributeValues" class="d-flex flex-column">
    <template v-for="customAttributeValue in this.customAttributeValues">
      <div>
        <span class="bi" :class="this.icon(customAttributeValue)"></span>
        {{ customAttributeValue.name }}
        <template v-if="this.isPresent(customAttributeValue)">
          <span v-if="customAttributeValue.castTo == 'integer'">({{ customAttributeValue.value }})</span>
          <span v-else-if="customAttributeValue.castTo == 'date'">(<vueTime :datetime="customAttributeValue.value" format="ccc, dd. LLL yyyy" />)</span>
          <span v-else-if="customAttributeValue.castTo == 'datetime'">(<vueTime :datetime="customAttributeValue.value" format="ccc, dd. LLLL yyyy HH:mm" />)</span>
          <span v-else-if="customAttributeValue.castTo == 'time'">({{ customAttributeValue.value.slice(0, 5) }})</span>
          <span v-else-if="customAttributeValue.castTo == 'single_select' || customAttributeValue.castTo == 'multi_select'">({{ this.labels(customAttributeValue) }})</span>
        </template>
      </div>
    </template>
  </div>

</template>
